import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  private _state: any = null;

  set state(data: any) {
    this._state = data;
  }

  get state(): any {
    const result = this._state;
    this._state = null; // clear after use
    return result;
  }

  private ineligibilityMessageSource = new BehaviorSubject<string | null>(null);
  ineligibilityMessage$ = this.ineligibilityMessageSource.asObservable();

  private ineligibilityDetailsSource =
    new BehaviorSubject<IneligibilityDetails | null>(null);
  ineligibilityDetails$ = this.ineligibilityDetailsSource.asObservable();

  // setIneligibilityMessage(message: string) {
  //   this.ineligibilityMessageSource.next(message);
  //   this.ineligibilityDetailsSource.next({ message });
  // }

  setIneligibilityDetails(details: IneligibilityDetails) {
    this.ineligibilityDetailsSource.next(details);
    this.ineligibilityMessageSource.next(details.message);
  }

  clearIneligibilityMessage() {
    this.ineligibilityMessageSource.next(null);
    this.ineligibilityDetailsSource.next(null);
  }

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  /**
   * Navigate to the appropriate dashboard based on user role
   */
  navigateToDashboard(): void {
    if (this.authService.isAdmin()) {
      this.router.navigate(['/hospital/admin/dashboard/donoroverview']);
    } else if (this.authService.isStaff()) {
      this.router.navigate(['/hospital/coordinator/dashboard']);
    } else {
      // Fallback to browser history if role is not determined
      window.history.back();
    }
  }

  /**
   * Navigate back to the appropriate dashboard based on user role
   * (Alias for navigateToDashboard for consistency)
   */
  goBack(): void {
    this.navigateToDashboard();
  }
}

export interface IneligibilityDetails {
  message: string;
  weightToLoseLbs?: number;
  targetWeightLbs?: number;
  bmiThreshold?: number;
}
